import { render, staticRenderFns } from "./LensInsightCard.vue?vue&type=template&id=3ec82ad8&scoped=true"
import script from "./LensInsightCard.vue?vue&type=script&lang=js"
export * from "./LensInsightCard.vue?vue&type=script&lang=js"
import style0 from "./LensInsightCard.vue?vue&type=style&index=0&id=3ec82ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec82ad8",
  null
  
)

export default component.exports